import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';

import { AppDispatch, RootState } from 'interfaces';

import Layout from 'components/Layout';
import AlbumDetailsComponent from 'components/AlbumDetails';
import StatisticSideBar from 'components/StatisticSideBar';

import Loader from 'components/ui/Loader';

import { getAlbumPlayedCount, getMostPlayedSongs } from 'features/statistics/statisticsSlice';

import { getAlbumDetails } from './albumsSlice';

const AlbumDetails = () => {
  const [searchParams] = useSearchParams();
  const { albumId } = useParams();
  const international = searchParams.get('international');

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getAlbumDetails({ albumId, international: international === 'true' }));
  }, [dispatch, albumId, international]);

  const albumDetails = useSelector((state: RootState) => state.albums.albumDetails);
  const albumNumber = useSelector((state: RootState) => state.albums.albumNumber);
  const songs = useSelector((state: RootState) => state.albums.songs);
  const singles = useSelector((state: RootState) => state.albums.singles);

  useEffect(() => {
    dispatch(getMostPlayedSongs({ tourId: null, albumId, limit: 10 }));
    dispatch(getAlbumPlayedCount({ albumId }));
  }, [dispatch, albumId]);

  const mostPlayedSongs = useSelector((state: RootState) => state.statistics.mostPlayedSongs);
  const albumPlayed = useSelector((state: RootState) => state.statistics.albumPlayed);


  return albumDetails ? (
      <Layout sidebar={(
        <div>
          <StatisticSideBar
            context="album"
            charts={albumDetails.charts}
            sells={albumDetails.statistics?.albumSells}
            albumPlayed={albumPlayed}
            mostPlayedSongs={mostPlayedSongs}
          />
        </div>
      )}>
        <AlbumDetailsComponent
          album={albumDetails}
          songs={songs}
          singles={singles}
          albumNumber={albumNumber}
          internationalAlbum={international === 'true'}
        />
      </Layout>
  ) : <Loader />;
};

export default AlbumDetails;
